export function generateSrcSet(url, widths) {
  return widths.map((width) => `${url}&width=${width} ${width}w`).join(', ')
}

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function ResultImage({ result, children }) {
  return (
    <div className="relative size-full overflow-hidden border-0">
      {result?.images?.length > 2 ? (
        <>
          <img
            className="absolute inset-0 object-cover size-full bg-[--section-bg-colour,theme(colors.brand.white)]"
            src={result.images[1].src}
            srcSet={generateSrcSet(result.images[1].src, IMAGE_WIDTHS)}
            sizes="50vw"
            alt={result.images[1].alt || result.title || 'Product image 1'}
          />
          <img
            className="absolute inset-0 object-cover size-full transition-all bg-[--section-bg-colour,theme(colors.brand.white)] group-hover/card:opacity-0"
            src={result.images[0].src}
            srcSet={generateSrcSet(result.images[0].src, IMAGE_WIDTHS)}
            sizes="50vw"
            alt={result.images[0].alt || result.title || 'Product image 2'}
          />
        </>
      ) : result.image ? (
        <img
          className="object-cover size-full bg-[--section-bg-colour,theme(colors.brand.white)] object-fit"
          src={result.image}
          srcSet={generateSrcSet(result.image, IMAGE_WIDTHS)}
          sizes="50vw"
          alt={result.image.alt || result.title || 'Product image'}
        />
      ) : null}
      {children}
    </div>
  )
}
